import React, { useEffect, useState } from "react";

import { Document, Page, pdfjs } from "react-pdf";

import Button from "components/form/Button";

import DocIcon from "icons/document/DocIcon";
import { DownloadIcon } from "icons/payments/DownloadIcon";

pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`;

interface DocPreviewProps {
  docUrl: string;
  onDownloadClick: (path: string, fileName: any, id?: string) => void;
  isDownloading: boolean;
  isPreviewLoading?: boolean;
  docTitle: string;
  newTitle?: string;
  id?: string;
  isDownloadedPreview?: boolean;
}

const DocPreview = ({
  docUrl,
  onDownloadClick,
  isDownloading,
  isPreviewLoading = false,
  docTitle,
  newTitle,
  id,
  isDownloadedPreview = false,
}: DocPreviewProps) => {
  const [numPages, setNumPages] = useState<number>(0);
  const [loadError, setLoadError] = useState<boolean>(false);
  const [viewportWidth, setViewportWidth] = useState<number>(window.innerWidth);

  useEffect(() => {
    const onResize = () => setViewportWidth(window.innerWidth);
    window.addEventListener("resize", onResize);
    return () => window.removeEventListener("resize", onResize);
  }, []);
  const pageWidth = viewportWidth < 810 ? viewportWidth - 80 : 810;

  const onDocumentLoadSuccess = ({ numPages }: any) => {
    setNumPages(numPages);
  };

  const onDocumentLoadError = (error: any) => {
    setLoadError(true);
    console.error("PDF load error:", error);
  };

  const PageBreak = () => <div className="my-5" />;

  return (
    <div
      style={{ height: "calc(var(--shell-vh) - 120px)" }}
      className="overflow-y-auto scrollbar-hide"
    >
      {!loadError && (
        <Document
          file={docUrl}
          onLoadSuccess={onDocumentLoadSuccess}
          loading={
            <div
              style={{ height: "calc(var(--shell-vh) - 120px)" }}
              className="h-full w-full flex justify-center items-center"
            >
              <div className="inline-block h-16 w-16 animate-spin rounded-full border-[5px] border-solid border-blue border-r-transparent align-[-0.125em] text-primary motion-reduce:animate-[spin_1.5s_linear_infinite]" />
            </div>
          }
          onLoadError={onDocumentLoadError}
        >
          {Array.from(new Array(numPages), (el, index) => (
            <React.Fragment key={`page_${index + 1}`}>
              <Page
                width={pageWidth}
                pageNumber={index + 1}
                renderTextLayer={false}
                renderAnnotationLayer={false}
                loading={
                  <div className="w-full flex justify-center items-center">
                    Page Loading...
                  </div>
                }
              />
              {index < numPages - 1 && <PageBreak />}
            </React.Fragment>
          ))}
        </Document>
      )}

      {loadError && (
        <div className="w-full h-full flex flex-col items-center justify-center gap-10">
          <DocIcon />
          <div className="w-full flex flex-col gap-4 items-center justify-center ">
            <p className="w-full text-xl font-medium text-txtPrimary text-center">
              Preview unavailable
            </p>
            <p className="w-full text-base text-txtSecondary">
              Please download the document to view it.
            </p>
          </div>
          <div className="w-full grid place-items-center">
            <Button
              text={isPreviewLoading ? "Downloading…" : "Download"}
              className="!w-fit"
              isDisabled={isDownloading}
              isLoading={false}
              isSuccess={isDownloadedPreview}
              img={
                isPreviewLoading ? (
                  <div className="h-5 w-5 border-2 border-white border-t-transparent rounded-full animate-spin" />
                ) : (
                  <DownloadIcon
                    strokeColor="var(--color-bg-primary)"
                    width="22"
                    height="22"
                  />
                )
              }
              onClick={() => {
                onDownloadClick(docTitle, newTitle, id);
              }}
            />
          </div>
        </div>
      )}
    </div>
  );
};

export default DocPreview;
